import React from 'react'
import { I18n, CDNSVG } from '@front/volcanion'

import { Grid, Button, Box, Icon, Typography } from '@mui/material'
import { TextField } from '@front/squirtle'

const typographyProps = {
  fontWeight: 100, fontSize: 13, WebkitTextFillColor: 'text.label'
}

const Passenger = ({ passenger_name, passenger_number, load_count, luggage }) =>
  <Box>
    <Box display='flex' justifyContent='center' overFlow='auto' gap={1}>
      <TextField name='passenger_name' InputProps={{ inputProps: { style: { ...typographyProps, textAlign: 'right' } } }} disabled />
      <Typography sx={{ ...typographyProps, fontWeight: 400 }}>-</Typography>
      <TextField name='passenger_number' InputProps={{ inputProps: { style: { ...typographyProps } } }} disabled />
    </Box>
    <Box display='flex' justifyContent='center' overFlow='auto' gap={1}>
      <Typography sx={typographyProps}> {load_count} {I18n.t('passenger.label', { count: 1 })}</Typography>
      <Typography sx={{ ...typographyProps, fontWeight: 400 }}>-</Typography>
      <Typography sx={typographyProps}> {I18n.t(`luggage.${!!luggage ? 'with' : 'without'}`)}</Typography>
    </Box>
  </Box >

const DisabledPassenger = props => <>
  <Box sx={{ display: 'flex', justifyContent: 'center', overFlow: 'auto' }}>
    <Typography sx={typographyProps}> {I18n.t('driver.notify')}</Typography>
  </Box>
</>

const PassengerSection = ({ disabledPassenger, openPassengerPopup, ...props }) =>
  <Grid item xs={12}>
    <Button sx={{ bgcolor: 'extraWhite', p: 1, textTransform: 'none' }} fullWidth onClick={openPassengerPopup} variant='outlined' disabled={disabledPassenger}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: 1 }} >
        <Box sx={{ color: 'primary.main', width: '4%', fontSize: 27 }}><Icon>{'group'}</Icon></Box>
        <Box sx={{ width: '92%' }}>{!disabledPassenger ? <Passenger {...props} /> : <DisabledPassenger />}</Box>
        <Box>
          <CDNSVG name='edit' fill='primary.main' category={'icons'} />
        </Box>
      </Box>
    </Button>
  </Grid>

export default React.memo(PassengerSection)
